<div class="stop-language-config">
  @if (this.showLanguageDropdown) {
    <div>
      <select class="form-control" [ngModel]="this.selectedResponseLanguage"
        (ngModelChange)="onLanguageChanged($event)" [disabled]="isLanguageControlDisabled">
        @for (language of this.dropdownOptions; track language) {
          <option value={{language}} [disabled]="isLanguageOptionDisabled(language)">
            {{languageMap[language]}}
          </option>
        }
      </select>
    </div>
  }
  <div [formGroup]="this.smsLanguageGroup">
    <textarea class="form-control" formControlName="response_template" rows="5" (change)="onMessageChanged()"></textarea>
  </div>
  <div class="clearfix">
    @if (this.showErrorDiv) {
      <div class="left-container">
        @if (this.showRequiredMessage) {
          <div>
            <small>A message must be provided.</small>
          </div>
        }
        @if (this.showMaxLengthMessage) {
          <div>
            <small>Message is too long.</small>
          </div>
        }
      </div>
    }
    <div class="right-container">
      <small>{{currentTextLength}}</small>
    </div>
  </div>
</div>
